import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { DashboardService } from 'src/app/dashboard.service';
import { Statistic } from 'src/app/dashboard';
import { Observable } from 'rxjs';
import {ReportService} from '../../services/report/report.service';

import { CompanyService } from '../../services/Company/company.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { RoleGuard } from 'src/app/core/guards/role.guard.spec';
import { OthersService} from '../../services/others/others.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  private empty: boolean = true;
  statistic: Statistic;
  branch: string = 'all';

  activity: any = [];

  // Get the actual branches on ngOnInit
  //branches: string[] = ['All Branches', 'KL Branch', 'PJ Branch'];
  branches: string[] = ['All ComCards'];

  total:any = {exchange:0,network:0,connect:0};
  total2:any = {bc:0,wc:0};

  currentCompany;
  showCreate = false;
  performaner:any = [];
  topindustry:any = [];
  totalnetwork = 0;

  constructor(private dashboardService: DashboardService, private route: ActivatedRoute, private router: Router, private companyService:CompanyService, private reportService:ReportService, private otherService:OthersService) {

    

  }

  ngOnInit(): void {
   
      
    
  }


  ngAfterViewInit() {
   
  }

  getActivity() {
    //alert(this.currentCompany.id);
      this.reportService.getHistory(this.currentCompany.id,{limit:5}).then((res:any)=>{
          //console.log("HISTORY: " + JSON.stringify(res));
          if (res.status == 'OK') {
            this.activity = res.data;
          }
      });
  }


  getTopIndustry() {
    this.reportService.getStats2(this.currentCompany.id).then((res:any)=>{
      //console.log("HISTORY: " + JSON.stringify(res));
      if (res.status == 'OK') {
        let m = res.data;

        this.topindustry = m;

      }
  });
  }

  switchBranch(e) {
    this.branch = e;
  }

  public regcomp() {
    this.router.navigate(['./company/create']);
  }


  getTotal() {
      this.reportService.getTotalStats(this.currentCompany.id).then((res:any)=>{

          if (res.status == 'OK') {

              this.total = res.data;

              let network = this.total.network;
              let nonzero = this.total.nonzero;

              if (nonzero && nonzero > 0) {
                 this.totalnetwork = parseInt(network+nonzero);
              }
          }
      });


      this.reportService.getTotalCardStats(this.currentCompany.id).then((res:any)=>{
        console.log("c=" + JSON.stringify(res));
        if (res.status == 'OK') {

         this.total2 = res.data;
       }
      });
  }


  parseDate(datestring) {
    //| date : 'M/d/yyyy, h:mm a'
    //let date = this.convertUTCDateToLocalDate(new Date(datestring));

    let m = new Date(datestring);

    let date1 = this.otherService.parseDate(datestring,'d/M/yyyy h:mm:a');

    //var newDate = new Date(m.getTime()-(m.getTimezoneOffset()*60*1000));

    //console.log("d=" + this.otherService.parseDate(newDate.toString(),'d/M/yyyy hh:mm a'));

    return m.getTime();
  }


  convertUTCDateToLocalDate(date) {
    //let date = this.parseDate(date1);
    var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;
}

receiveMessage(event) {
  alert(event)
}

}
